import { render, staticRenderFns } from "./ProfitList.vue?vue&type=template&id=cb0f618c&scoped=true&"
import script from "./ProfitList.vue?vue&type=script&lang=ts&"
export * from "./ProfitList.vue?vue&type=script&lang=ts&"
import style0 from "./ProfitList.vue?vue&type=style&index=0&id=cb0f618c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0f618c",
  null
  
)

export default component.exports